import { Messages } from 'constants/rpcTypes';

export const manualPaymentsTabs = [
  {
    id: 'refund',
    path: 'mass-refunds-form',
    label: 'payouts.request.tabs.mass.refund',
    permission: Messages.BulkPayouts_UploadRefund,
  },
  {
    id: 'capture',
    path: 'mass-captures-form',
    label: 'payouts.request.tabs.capture',
    permission: Messages.BulkPayouts_UploadCapture,
  },
  {
    id: 'cancel',
    path: 'mass-cancels-form',
    label: 'payouts.request.tabs.cancel',
    permission: Messages.BulkPayouts_UploadCancel,
  },
];
